import { Props as StoreblocksAutosuggestProps } from "@storeblocks/autosuggest";
import { isDefined } from "Utils/functions";
import { startsWithIgnoreCase } from "Utils/stringUtils";
import { useField } from "formik";
import React from "react";
import { StyledAutosuggest } from "./autosuggestStyled";

interface Props extends StoreblocksAutosuggestProps {
  marginBottom?: "0px" | "32px";
}

export const Autosuggest = ({
  name,
  onChange,
  filter = startsWithIgnoreCase,
  dropdownEnabled = true,
  noItemFoundText = "Ingen treff",
  marginBottom = "32px",
  ...props
}: Props): React.ReactElement => {
  const [field] = useField(name);
  return (
    <StyledAutosuggest
      {...props}
      {...field}
      onChange={(event) => {
        field.onChange(event);
        isDefined(onChange) && onChange(event);
      }}
      filter={filter}
      dropdownEnabled={dropdownEnabled}
      noItemFoundText={noItemFoundText}
      marginBottom={marginBottom}
    />
  );
};
